import { Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject, Subscription } from "rxjs";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { UntypedFormControl } from "@angular/forms";
import {
  SegmentService,
  PixelService,
} from "src/app/core/services/pixel.service";
import { CreativeService } from "src/app/core/services/creative.service";
import { GeoService } from "src/app/core/services/geo.service";
import { ALIService } from "../../../../core/services/ali.service";
export interface Country {
  id: number;
  name: string;
}
export interface Region {
  id: number;
  name: string;
}
export interface City {
  id: number;
  country_name: string;
}
export interface Dma {
  id: number;
  name: string;
}
export interface PostalCodes {
  id: number;
  code: string;
}
export interface FirstPartySegment {
  id: number;
  short_name: string;
}
export interface ThirdPartySegment {
  id: number;
  name: string;
}
export interface Creatives {
  advertiser_id: number;
  short_name: string;
  type: string;
}
export interface Conversion {
  id: number;
  name: string;
  pixel_type: string;
}
// advertiser_id

// short_name
@Component({
  selector: "app-dailog",
  templateUrl: "./dailog.component.html",
  styleUrls: ["./dailog.component.scss"],
})

export class DailogComponent implements OnInit {
  public modeldata = "hello from model";
  public model;
  public slectedTab;
  public selectedCreatives = [];
  // ;
  public selectedPixel = [];
  viewMode;
  allCountry: Array<any> = [];
  allCity = [];
  allRegion = [];
  allDma = [];
  allPostalCodes = [];
  allFirstPartySegment = [];
  allThirdPartySegment = [];
  segmentTab;
  countrySelected: Array<any> = [];
  citySelected: Array<any> = [];
  regionSelected: Array<any> = [];
  dmaSelected: Array<any> = [];
  postalCodesSelected = [];
  postalCodes: Array<any> = [];

  countryIncludeOrExclude = "include";
  cityIncludeOrExclude = "include";
  regionIncludeOrExclude = "include";
  dmaIncludeOrExclude = "include";
  postalcodeIncludeOrExclude = "include";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<any>,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    public _aliServices: ALIService,
    public pixelService: PixelService,
    public geoService: GeoService,
    public creativeService: CreativeService,
    public segmentService: SegmentService
  ) {}

  // @ViewChild(DataTableDirective)

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator1: MatPaginator;
  @ViewChild(MatSort) sort1: MatSort;
  @ViewChild(MatPaginator) paginator2: MatPaginator;
  @ViewChild(MatSort) sort2: MatSort;
  @ViewChild(MatPaginator) paginatorDma: MatPaginator;
  @ViewChild(MatSort) sortDma: MatSort;
  @ViewChild(MatPaginator) paginatorPostalCodes: MatPaginator;
  @ViewChild(MatSort) sortPostalCodes: MatSort;
  @ViewChild(MatPaginator) paginatorFirstParty: MatPaginator;
  @ViewChild(MatSort) sortFirstParty: MatSort;
  @ViewChild(MatPaginator) paginatorThirdParty: MatPaginator;
  @ViewChild(MatSort) sortThirdParty: MatSort;
  @ViewChild(MatPaginator) paginatorCreatives: MatPaginator;
  @ViewChild(MatSort) sortCreatives: MatSort;
  @ViewChild(MatPaginator) paginatorConversion: MatPaginator;
  @ViewChild(MatSort) sortConversion: MatSort;

  subscription: Subscription;

  disabledToggle: Number[] = [];
  segmentGroup: Array<any> = [];
  creatives: Array<any> = [];
  pixels: Array<any> = [];

  showOrBadge = true;
  segment_boolean_operator = "or";
  selectedsegmentGroup = [[]];
  displayedColumns: string[] = ["id", "name"];

  displayedColumnsRegion: string[] = ["id", "name"];
  displayedColumnCity: string[] = ["id", "name"];
  displayedColumnsDma: string[] = ["id", "name"];
  displayedColumnsPostalCodes: string[] = ["id", "code"];
  displayedColumnsFirstParty: string[] = ["checkbox", "id", "short_name"];
  displayedColumnsThirdParty: string[] = ["checkbox", "id", "short_name"];
  displayedColumnsCreatives: string[] = ["checkbox", "id", "name", "type"];
  displayedColumnsConversion: string[] = ["checkbox", "id", "name", "type"];
  dataSourceCountry: MatTableDataSource<Country>;
  dataSourceRegion: MatTableDataSource<Region>;
  dataSourceCity: MatTableDataSource<City>;
  dataSourceDma: MatTableDataSource<Dma>;
  dataSourcePostalCodes: MatTableDataSource<PostalCodes>;
  dataSourceFirstPartySegment: MatTableDataSource<FirstPartySegment>;
  dataSourceThirdPartySegment: MatTableDataSource<ThirdPartySegment>;
  dataSourceCreatives: MatTableDataSource<Creatives>;
  dataSourceConversion: MatTableDataSource<Conversion>;
  ngOnInit(): void {
    this.slectedTab = this.data.tab;
    this.segmentTab = this.data.tab;
    this.model = this.data.dailog;

    if (this.model == "conversion") {
      this.selectedPixel = this.data.data;
      this.getAllPixels();
    }

    if (this.model == "creatives") {
      this.selectedCreatives = this.data.data;
      this.getAllCreatives();
    }
    if (this.model == "targeting") {
      this.setGeoData();
      this.dataSourceCountry = new MatTableDataSource(this.allCountry);
      this.dataSourceRegion = new MatTableDataSource(this.allRegion);
      this.dataSourceCity = new MatTableDataSource(this.allCity);
      this.dataSourceDma = new MatTableDataSource(this.allDma);
      this.dataSourcePostalCodes = new MatTableDataSource(this.allPostalCodes);
      this.changeViewMode("1");
    }
    if (this.model == "segment") {
      this.getFirstPartySegment();
      this.getAllthirdPartySegment();
      this.setSegmentData();
    }
  }

  selected = new UntypedFormControl(0);
  public tabValue = 0;
  geoView(val) {
    if (val == 0) {
      this.tabValue = 0;
      this.getAllCountries();
    }
    if (val == 1) {
      this.tabValue = 1;
      this.getAllRegion();
    }
    if (val == 2) {
      this.tabValue = 2;
      this.getAllCity();
    }
    if (val == 3) {
      this.tabValue = 3;
      this.getAllDma();
    }
    if (val == 4) {
      this.tabValue = 4;
      this.getAllPostalCode();
    }
  }

  segementView(val) {
    if (val == 0) {
      this.segmentTab = 0;
      this.getFirstPartySegment();
    }
    if (val == 1) {
      this.segmentTab = 1;
      this.getAllthirdPartySegment();
    }
  }

  addNewSegment() {
    if (this.segmentGroup[this.segmentGroup.length - 1].length > 0) {
      this.segmentGroup.push([1, 2, 3]);
    }
  }

  checkIndexOf(item) {
    let flag = false;
    let a = [...this.selectedsegmentGroup];
    if (a.indexOf(item) >= 0) {
      return true;
    } else {
      return false;
    }
  }

  applyFilterCountry(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    if (filterValue.length < 3) {
      return this.getAllCountries();
    }
    this.geoService
      .getCountries("search_fields=name", `&name=${filterValue}`, "")
      .subscribe(
        (res) => {
          this.allCountry = res["countries"];
          this.dataSourceCountry = new MatTableDataSource(this.allCountry);
          this.dataSourceCountry.paginator = this.paginator;
          this.dataSourceCountry.sort = this.sort;
        },
        () => {
          console.log("error");
        },
        () => {
          this.countrySelected.forEach((ele) => {
            this.removeElementfromlist(this.allCountry, ele);
          });
        }
      );
  }

  applyFilterRegion(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (filterValue.length < 3) {
      return this.getAllRegion();
    }
    var searchFields = "";
    var excludes = "";
    var searchValues = "";

    if (this.countrySelected.length != 0) {
      this.countrySelected.forEach((item) => {
        if (searchValues === "") {
          searchValues += "&country_name=" + item.name;
        } else {
          searchValues += "," + item.name;
        }
      });
      searchFields = `,country_name`;
      if (this.countryIncludeOrExclude == "exclude") {
        excludes = "&excludes=country_name";
      }
    }
    this.geoService
      .getRegions(
        "&search_fields=name" + searchFields,
        `&name=${filterValue}` + searchValues,
        excludes
      )
      .subscribe(
        (res) => {
          this.allRegion = res["regions"];
          this.dataSourceRegion = new MatTableDataSource(this.allRegion);
          this.dataSourceRegion.paginator = this.paginator;
          this.dataSourceRegion.sort = this.sort;
        },
        () => {
          console.log("error");
        },
        () => {
          this.regionSelected.forEach((ele) => {
            this.removeElementfromlist(this.allRegion, ele);
          });
        }
      );
  }

  applyFilterCity(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (filterValue.length < 3) {
      return this.getAllCity();
    }
    var searchFields = "";
    var excludes = "";
    var searchValues = "";

    if (this.countrySelected.length != 0) {
      this.countrySelected.forEach((item) => {
        let countries = "";
        searchValues = "&country_name=";
        if (countries == "") {
          searchValues += item.name;
        } else {
          searchValues += "," + item.name;
        }
      });
      searchFields += ",country_name";
    }
    if (this.regionSelected.length != 0) {
      this.regionSelected.forEach((item) => {
        let regions = "";
        searchValues += "&region_name=";
        if (regions == "") {
          searchValues += item.name;
        } else {
          searchValues += "," + item.name;
        }
      });
      searchFields += ",region_name";
    }
    if (this.countryIncludeOrExclude == "exclude") {
      excludes = "&excludes=country_name";
    }
    if (this.regionIncludeOrExclude == "exclude") {
      if (excludes == "") {
        excludes = "&excludes=region_name";
      } else {
        excludes += ",region_name";
      }
    }
    this.geoService
      .getCities(
        "&search_fields=name" + searchFields,
        `&name=${filterValue}` + searchValues,
        excludes
      )
      .subscribe(
        (res) => {
          this.allCity = res["cities"];
          this.dataSourceCity = new MatTableDataSource(this.allCity);
          this.dataSourceCity.paginator = this.paginator;
          this.dataSourceCity.sort = this.sort;
        },
        () => {
          console.log("error");
        },
        () => {
          this.regionSelected.forEach((ele) => {
            this.removeElementfromlist(this.allCity, ele);
          });
        }
      );
  }
  applyFilterDma(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (filterValue.length < 3) {
      return this.getAllDma();
    }
    var searchFields = "";
    var excludes = "";
    var searchValues = "";

    if (this.countrySelected.length != 0) {
      this.countrySelected.forEach((item) => {
        if (searchValues === "") {
          searchValues += "&country_name=" + item.name;
        } else {
          searchValues += "," + item.name;
        }
      });
      searchFields = `,country_name`;
      if (this.countryIncludeOrExclude == "exclude") {
        excludes = "&excludes=country_name";
      }
    }
    // this.geoService
    //   .getDmas(
    //     "search_fields=name" + searchFields,
    //     `&name=${filterValue}` + searchValues,
    //     excludes
    //   )
    //   .subscribe(
    //     (res) => {
    //       this.allDma = res["dmas"];
    //       this.dataSourceDma = new MatTableDataSource(this.allDma);
    //       this.dataSourceDma.paginator = this.paginator;
    //       this.dataSourceDma.sort = this.sort;
    //     },
    //     () => {
    //       console.log("error");
    //     },
    //     () => {
    //       this.regionSelected.forEach((ele) => {
    //         this.removeElementfromlist(this.allDma, ele);
    //       });
    //     }
    //   );
  }

  applyFilterPostalCodes(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (filterValue.length < 3) {
      return this.getAllPostalCode();
    }
    var searchFields = "";
    var excludes = "";
    var searchValues = "";

    if (this.countrySelected.length != 0) {
      this.countrySelected.forEach((item) => {
        if (searchValues === "") {
          searchValues += "&country_name=" + item.name;
        } else {
          searchValues += "," + item.name;
        }
      });
      searchFields = `,country_name`;
      if (this.countryIncludeOrExclude == "exclude") {
        excludes = "&excludes=country_name";
      }
    }
    this.geoService
      .getPostalCodes(
        "search_fields=code" + searchFields,
        `&code=${filterValue}` + searchValues,
        excludes
      )
      .subscribe(
        (res) => {
          this.allPostalCodes = res["postal_codes"];
          this.dataSourcePostalCodes = new MatTableDataSource(
            this.allPostalCodes
          );
          this.dataSourcePostalCodes.paginator = this.paginator;
          this.dataSourcePostalCodes.sort = this.sort;
        },
        () => {
          console.log("error");
        },
        () => {
          this.regionSelected.forEach((ele) => {
            this.removeElementfromlist(this.allPostalCodes, ele);
          });
        }
      );
  }

  applyFirstPartyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceFirstPartySegment.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceFirstPartySegment.paginator) {
      this.dataSourceFirstPartySegment.paginator.firstPage();
    }
  }
  applyThirdPartyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceThirdPartySegment.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceThirdPartySegment.paginator) {
      this.dataSourceThirdPartySegment.paginator.firstPage();
    }
  }
  applyCreativesFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceCreatives.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceCreatives.paginator) {
      this.dataSourceCreatives.paginator.firstPage();
    }
  }
  applyConversionFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceConversion.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceConversion.paginator) {
      this.dataSourceConversion.paginator.firstPage();
    }
  }
  pushFirstPartySegment(item) {
    if (this.selectedsegmentGroup.length == 0) {
      this.selectedsegmentGroup.push([]);
    }
    let flag = true;
    this.selectedsegmentGroup.forEach((el) => {
      if (el.indexOf(item) >= 0) {
        el.splice(el.indexOf(item), 1);
        flag = false;
      }
    });
    if (flag == true) {
      this.selectedsegmentGroup[this.selectedsegmentGroup.length - 1].push(
        item
      );
    }
  }

  removsegment(item) {
    this.selectedsegmentGroup.forEach((el) => {
      if (el.indexOf(item) >= 0) {
        el.splice(el.indexOf(item), 1);
      }
    });
    this.selectedsegmentGroup.forEach((el) => {
      if (el.length == 0) {
        this.selectedsegmentGroup.splice(
          this.selectedsegmentGroup.indexOf(el),
          1
        );
      }
    });
  }
  addnewsegmentGroup() {
    if (
      this.selectedsegmentGroup[this.selectedsegmentGroup.length - 1].length !=
      0
    ) {
      this.selectedsegmentGroup.push([]);
    }
  }

  action: Array<any> = [
    { value: "Activate", label: "Active" },
    { value: "Deactivate", label: "Deactive" },
    { value: "Dates", label: "Dates" },
  ];
  dateRange: Array<any> = [
    { value: "Activate", label: "Action" },
    { value: "Deactivate", label: "Today" },
    { value: "Dates", label: "Last 7 Days" },
    { value: "Dates", label: "Last 30 Days" },
    { value: "Dates", label: "Month to Date Last Month" },
  ];
  Show: Array<any> = [
    { value: "Activate", label: "All" },
    { value: "Deactivate", label: "Active" },
    { value: "Dates", label: "Inactive" },
  ];
  budget = "Activate";

  getAllthirdPartySegment() {
    let params = { segment_type: "third`" };
    this.segmentService.list(params).subscribe(
      (res) => {
        this.allThirdPartySegment = res["segments"];
        this.dataSourceThirdPartySegment = new MatTableDataSource(
          this.allThirdPartySegment
        );
        this.dataSourceThirdPartySegment.paginator = this.paginatorThirdParty;

        this.dataSourceThirdPartySegment.sort = this.sortThirdParty;
      },
      () => {
        console.log("error");
      }
    );
  }

  changeViewMode(val) {
    this.viewMode = val;
    if (this.viewMode == "1") {
      this.getAllCountries();
    }
    if (this.viewMode == "2") {
      this.getAllRegion();
    }
    if (this.viewMode == "3") {
      this.getAllCity();
    }
    if (this.viewMode == "4") {
      this.getAllDma();
    }
    if (this.viewMode == "5") {
      this.getAllPostalCode();
    }
  }

  removeElementfromlist(list: Array<any>, element) {
    var index = 0;
    list.forEach((ele) => {
      if (ele.id == element.id) {
        list.splice(index, 1);
      }
      index++;
    });
  }

  isHide(val) {
    if (this.viewMode === val) {
      return true;
    }
  }
  public advertiserId = 4256938;
  getAllCreatives() {
    let params = { advertiser_id: this.advertiserId };

    this.creativeService.list(params).subscribe(
      (res) => {
        this.creatives = res["creatives"];
        this.dataSourceCreatives = new MatTableDataSource(this.creatives);
        this.dataSourceCreatives.paginator = this.paginatorCreatives;
        this.dataSourceCreatives.sort = this.sortCreatives;
      },
      () => {
        console.log("error");
      },
      () => {
        this.selectedCreatives.forEach((ele) => {
          this.removeElementfromlist(this.creatives, ele);
        });
      }
    );
  }
  checkIndexOfCreatives(item) {
    return true;
    if (this.selectedCreatives.indexOf(item) >= 0) {
    }
  }

  setGeoData() {
    let geoData = this.data.data1;
    this.countrySelected = geoData.country;
    this.citySelected = geoData.city;
    this.regionSelected = geoData.region;
    this.dmaSelected = geoData.dma;
    this.postalCodesSelected = geoData.postal;
    this.countryIncludeOrExclude = geoData.country_action;
    this.cityIncludeOrExclude = geoData.city_action;
    this.regionIncludeOrExclude = geoData.region_action;
    this.dmaIncludeOrExclude = geoData.dma_action;
  }

  setSegmentData() {
    this.selectedsegmentGroup = this.data.data;
    this.segment_boolean_operator = this.data.segment_boolean_operator;
  }
  getFirstPartySegment() {
    let params = { segment_type: "first" };
    this.segmentService.list(params).subscribe(
      (res) => {
        this.segmentGroup = res["segments"];
        this.dataSourceFirstPartySegment = new MatTableDataSource(
          this.segmentGroup
        );
        this.dataSourceFirstPartySegment.paginator = this.paginatorFirstParty;
        this.dataSourceFirstPartySegment.sort = this.sortFirstParty;
      },
      () => {
        console.log("error");
      }
    );
  }

  getAllCountries() {
    this.geoService.getCountries().subscribe(
      (res) => {
        this.allCountry = res["countries"];
        this.dataSourceCountry = new MatTableDataSource(this.allCountry);
        this.dataSourceCountry.paginator = this.paginator;
        this.dataSourceCountry.sort = this.sort;
      },
      () => {
        console.log("error");
      },
      () => {
        this.countrySelected.forEach((ele) => {
          this.removeElementfromlist(this.allCountry, ele);
        });
      }
    );
  }

  getAllCity() {
    var searchFields = "";
    var excludes = "";
    var searchValues = "";

    if (this.countrySelected.length != 0) {
      this.countrySelected.forEach((item) => {
        let countries = "";
        searchValues = "&country_name=";
        if (countries == "") {
          searchValues += item.name;
        } else {
          searchValues += "," + item.name;
        }
      });
      if (searchFields == "") {
        searchFields += `&search_fields=country_name`;
      } else {
        searchFields += ",country_name";
      }
    }
    if (this.regionSelected.length != 0) {
      this.regionSelected.forEach((item) => {
        let regions = "";
        searchValues += "&region_name=";
        if (regions == "") {
          searchValues += item.name;
        } else {
          searchValues += "," + item.name;
        }
      });
      if (searchFields == "") {
        searchFields += `&search_fields=region_name`;
      } else {
        searchFields += ",region_name";
      }
    }
    if (this.countryIncludeOrExclude == "exclude") {
      excludes = "&excludes=country_name";
    }
    if (this.regionIncludeOrExclude == "exclude") {
      if (excludes == "") {
        excludes = "&excludes=region_name";
      } else {
        excludes += ",region_name";
      }
    }
    this.geoService.getCities(searchFields, searchValues, excludes).subscribe(
      (res) => {
        this.allCity = res["cities"];
        this.dataSourceCity = new MatTableDataSource(this.allCity);
        this.dataSourceCity.paginator = this.paginator2;
        this.dataSourceCity.sort = this.sort2;
      },
      () => {
        console.log("error");
      },
      () => {
        this.citySelected.forEach((ele) => {
          this.removeElementfromlist(this.allCity, ele);
        });
      }
    );
  }

  getAllRegion() {
    var searchFields = "";
    var excludes = "";
    var searchValues = "";

    if (this.countrySelected.length != 0) {
      this.countrySelected.forEach((item) => {
        if (searchValues === "") {
          searchValues += "&country_name=" + item.name;
        } else {
          searchValues += "," + item.name;
        }
      });
      searchFields = `&search_fields=country_name`;
      if (this.countryIncludeOrExclude == "exclude") {
        excludes = "&excludes=country_name";
      }
    }
    this.geoService.getRegions(searchFields, searchValues, excludes).subscribe(
      (res) => {
        this.allRegion = res["regions"];
        // this.rerender();
        this.dataSourceRegion = new MatTableDataSource(this.allRegion);
        // this.rerender();
        this.dataSourceRegion.paginator = this.paginator;
        // ''

        this.dataSourceRegion.sort = this.sort;
      },
      () => {
        console.log("error");
      },
      () => {
        this.regionSelected.forEach((ele) => {
          this.removeElementfromlist(this.allRegion, ele);
        });
      }
    );
  }

  getAllPostalCode() {
    var searchFields = "";
    var excludes = "";
    var searchValues = "";

    if (this.countrySelected.length != 0) {
      this.countrySelected.forEach((item) => {
        if (searchValues === "") {
          searchValues += "&country_name=" + item.name;
        } else {
          searchValues += "," + item.name;
        }
      });
      searchFields = `&search_fields=country_name`;
      if (this.countryIncludeOrExclude == "exclude") {
        excludes = "&excludes=country_name";
      }
    }
    // var search = "";
    // var exclusion = "";
    // var county_query = "";

    // if (this.countrySelected.length != 0) {
    //   this.countrySelected.forEach((item) => {
    //     if (county_query === "") {
    //       county_query += item.name;
    //     } else {
    //       county_query += "," + item.name;
    //     }
    //   });
    //   search = `&search_field=country_name&search=${county_query}`;
    //   if (this.countryIncludeOrExclude == "exclude") {
    //     exclusion = "&exclude=true";
    //   }
    // }

    this.geoService
      .getPostalCodes(searchFields, searchValues, excludes)
      .subscribe(
        (res) => {
          this.allPostalCodes = res["postal_codes"];
          // this.rerender();
          // this.allDma = res["dmas"];

          // this.rerender();
          this.dataSourcePostalCodes = new MatTableDataSource(
            this.allPostalCodes
          );
          // this.rerender();
          this.dataSourcePostalCodes.paginator = this.paginatorPostalCodes;

          this.dataSourcePostalCodes.sort = this.sortPostalCodes;
        },
        () => {
          console.log("error");
        },
        () => {
          this.postalCodesSelected.forEach((ele) => {
            this.removeElementfromlist(this.allPostalCodes, ele);
          });
        }
      );
  }

  getAllDma() {
    var searchFields = "";
    var excludes = "";
    var searchValues = "";

    if (this.countrySelected.length != 0) {
      this.countrySelected.forEach((item) => {
        if (searchValues === "") {
          searchValues += "&country_name=" + item.name;
        } else {
          searchValues += "," + item.name;
        }
      });
      searchFields = `&search_fields=country_name`;
      if (this.countryIncludeOrExclude == "exclude") {
        excludes = "&excludes=country_name";
      }
    }

    this.geoService.getDmas(searchFields, searchValues, excludes).subscribe(
      (res) => {
        this.allDma = res["dmas"];
        // this.rerender();
        this.dataSourceDma = new MatTableDataSource(this.allDma);
        // this.rerender();
        this.dataSourceDma.paginator = this.paginatorDma;

        this.dataSourceDma.sort = this.sortDma;
      },
      () => {
        console.log("error");
      },
      () => {
        this.dmaSelected.forEach((ele) => {
          this.removeElementfromlist(this.allDma, ele);
        });
      }
    );
  }
  countryType: Array<any> = [
    { value: "usa", label: "USA" },
    { value: "canada", label: "Canada" },
    { value: "uk", label: "UK" },
  ];
  actionType: Array<any> = [
    { value: "include", label: "Include" },
    { value: "exclude", label: "Exclude" },
  ];

  getAllPixels() {
    let params = { advertiser_id: this.advertiserId };
    this.pixelService.list(params).subscribe(
      (res) => {
        this.pixels = res["pixels"];
        // this.rerender();
      },
      () => {
        console.log("error");
      },
      () => {
        this.selectedPixel.forEach((ele) => {
          this.removeElementfromlist(this.pixels, ele);
        });
        this.dataSourceConversion = new MatTableDataSource(this.pixels);
        // this.rerender();
        this.dataSourceConversion.paginator = this.paginatorConversion;

        this.dataSourceConversion.sort = this.sortConversion;
      }
    );

    // this.selectedPixel.forEach((item) => {
    //   this.pixels.splice(this.pixels.indexOf(item), 1);
    // });
  }
  closeDailog() {}
  closeModal() {
    this.modalService.dismissAll();
  }

  addCreatives(val) {
    // this.targetingDevices.push(val);
    let index = this.selectedCreatives.indexOf(val);

    if (this.selectedCreatives.indexOf(val) < 0) {
      this.selectedCreatives.push(val);
      this.creatives.splice(this.creatives.indexOf(val), 1);
    } else if (this.selectedCreatives.indexOf(val) >= 0) {
      this.selectedCreatives.splice(index, 1);
    }
  }
  addPixel(val) {
    // this.targetingDevices.push(val);
    let index = this.selectedPixel.indexOf(val);

    if (this.selectedPixel.indexOf(val) < 0) {
      this.selectedPixel.push(val);

      this.pixels.splice(this.pixels.indexOf(val), 1);
      // this.rerender()
    } else if (this.selectedPixel.indexOf(val) >= 0) {
      this.selectedPixel.splice(index, 1);
    }
  }

  addCountrytoSelected(country) {
    if (this.countrySelected.indexOf(country) === -1) {
      this.countrySelected.push(country);
      this.allCountry.splice(this.allCountry.indexOf(country), 1);
    } else {
      this.countrySelected.splice(this.countrySelected.indexOf(country), 1);
    }
  }

  removeSelectedCountry(country) {
    this.countrySelected.splice(this.countrySelected.indexOf(country), 1);
    this.allCountry.push(country);
  }

  addCitytoSelected(country) {
    if (this.citySelected.indexOf(country) === -1) {
      this.citySelected.push(country);
    } else {
      this.citySelected.splice(this.citySelected.indexOf(country), 1);
    }
  }

  removeSelectedCity(val) {
    this.citySelected.splice(this.citySelected.indexOf(val), 1);
  }
  addRegiontoSelected(country) {
    if (this.regionSelected.indexOf(country) === -1) {
      this.regionSelected.push(country);
    } else {
      this.regionSelected.splice(this.regionSelected.indexOf(country), 1);
    }
  }

  addDmaSelected(country) {
    if (this.dmaSelected.indexOf(country) === -1) {
      this.dmaSelected.push(country);
    } else {
      this.dmaSelected.splice(this.dmaSelected.indexOf(country), 1);
    }
  }
  addPostalcodesSelected(country) {
    if (this.postalCodesSelected.indexOf(country) === -1) {
      this.postalCodesSelected.push(country);
    } else {
      this.postalCodesSelected.splice(
        this.postalCodesSelected.indexOf(country),
        1
      );
    }
  }

  saveSegmentData(val, saveData) {
    this.dialogRef.close({
      event: "close",
      segment_boolean_operator: this.segment_boolean_operator,
      data: this.selectedsegmentGroup,
      id: "hello",
      saveData: saveData,
    });
  }
  removeSelectedCreatives(val) {
    let index = this.selectedCreatives.indexOf(val);

    this.selectedCreatives.splice(index, 1);
    this.creatives.push(val);
  }
  removeSelectedPixel(val) {
    let index = this.selectedPixel.indexOf(val);

    this.selectedPixel.splice(index, 1);

    this.pixels.push(val);
  }

  removeAllPixel() {
    this.selectedPixel = [];
  }

  removeAllCreatives() {
    this.selectedCreatives = [];
  }
  removeAllCountry() {
    this.countrySelected = [];
  }

  saveGeoData(val, saveData) {
    this.dialogRef.close({
      event: "close",
      data: {
        country: [...this.countrySelected],
        region: this.regionSelected,
        postal: this.postalCodesSelected,
        dma: this.dmaSelected,
        city: this.citySelected,
        region_action: this.regionIncludeOrExclude,
        dma_action: this.dmaIncludeOrExclude,
        city_action: this.countryIncludeOrExclude,
        country_action: this.cityIncludeOrExclude,
        saveData: saveData,
      },
      id: "78",
    });
  }

  closeCreativesModel(val, saveData) {
    this.dialogRef.close({
      event: "close",
      data: this.selectedCreatives,
      id: "hello",
      saveData: saveData,
    });
  }

  closeConversionModel(val, saveDate) {
    this.dialogRef.close({
      event: "close",
      data: this.selectedPixel,
      saveData: saveDate,
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    // this.dtTrigger.unsubscribe();
    // this.subscription.unsubscribe();
    // this.dtTriggerRegion.unsubscribe();
  }

  // ngAfterViewInit() {
  //   this.dtTrigger.next();
  // }
  ngAfterViewInit() {
    // this.dtTrigger.next();
    // this.dataSourceCountry.paginator = this.paginator;
    // this.dataSourceCountry.sort = this.sort;
    // this.dataSourceThirdPartySegment.paginator = this.paginatorThirdParty;
    // this.dataSourceThirdPartySegment.sort = this.sortThirdParty;
    // this.dataSourceFirstPartySegment.paginator = this.paginatorFirstParty;
    // this.dataSourceFirstPartySegment.sort = this.sortFirstParty;
    // this.dataSource1.paginator = this.paginator1;
    // this.dataSource1.sort = this.sort1;
    // this.dataSource2.paginator = this.paginator2;
    // this.dataSource2.sort = this.sort2;
    // this.dataSource3.paginator = this.paginator3;
    // this.dataSource3.sort = this.sort3;
  }

  // rerender(): void {
  //   if (this.dtElement.dtInstance) {
  //     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //       // Destroy the table first
  //       dtInstance.destroy();
  //       // Call the dtTrigger to rerender again
  //       // this.dtTrigger.next();
  //       // this.dtTriggerRegion.next();
  //     });
  //   }
  // }
  state = "active";

  setStatus(val) {
    // event.stopImmediatePropagation()
    this.state = val;
  }

  openDeleteModel() {}
}
